export interface AppConfig {
  apiBase: string;
  googleClientId: string;
  appleServiceId: string;
  appleRedirectUrl: string;
}

let appConfig: AppConfig | undefined;

export async function loadConfig(): Promise<void> {
  const res = await fetch('/config.json');
  if (!res.ok) {
    throw new Error(`Failed to load config: ${res.status}`);
  }
  appConfig = (await res.json()) as AppConfig;
}

export function getConfig(): AppConfig {
  if (!appConfig) {
    throw new Error('Config not loaded yet');
  }
  return appConfig;
}

